import {
    Dispatch,
    SetStateAction,
    useMemo
} from "react";

import { Avatar } from "@mui/material";
import { DrawerListItemButton } from "../DrawerListItemButton";
import UserIcon from "../../icons/UserIcon";
import { useUser } from "../../user/UserContext";

type UserProfileSectionProps = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const UserProfileSection = ({ isOpen, setIsOpen }: UserProfileSectionProps) => {
    const { userAttributes } = useUser();

    const userDisplayName = useMemo(() => {
        if (!userAttributes?.["given_name"] && !userAttributes?.["family_name"]) {
            return userAttributes?.["email"];
        }
        return `${userAttributes?.["given_name"]} ${userAttributes?.["family_name"]}`;
    }, [userAttributes]);

    return (
        <DrawerListItemButton
            title={userDisplayName ?? ""}
            icon={<UserIcon />}
            isOpen={isOpen}
            linkTo="/profile"
            onClick={() => setIsOpen(false)}
            sx={{
                visibility: isOpen ? "visible" : "hidden"
            }}
        />
    );
}; 